/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_NameInputs */

const en_mk_sol_agensi_name = /** @type {(inputs: Mk_Sol_Agensi_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`digital agencies & production studios`)
};

const id_mk_sol_agensi_name = /** @type {(inputs: Mk_Sol_Agensi_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agensi digital & rumah produksi`)
};

/**
* | output |
* | --- |
* | "digital agencies & production studios" |
*
* @param {Mk_Sol_Agensi_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_name = /** @type {((inputs?: Mk_Sol_Agensi_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_name(inputs)
	return en_mk_sol_agensi_name(inputs)
});